import React from 'react';
import Button from '../common/Button';

interface SocialLoginButtonsProps {
  className?: string;
  planType?: string;
  planDuration?: string;
  currency?: string;
}

const SocialLoginButtons: React.FC<SocialLoginButtonsProps> = ({ 
  className = '', 
  planType = 'basic',
  planDuration = 'monthly',
  currency = 'NGN'
}) => {
  const handleGoogleLogin = () => {
    sessionStorage.setItem('planType', planType);
    sessionStorage.setItem('planDuration', planDuration);
    sessionStorage.setItem('currency', currency);
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google?plan=${planType}&duration=${planDuration}`;
  };

  const handleTwitterLogin = () => {
    sessionStorage.setItem('planType', planType);
    sessionStorage.setItem('planDuration', planDuration);
    sessionStorage.setItem('currency', currency);
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/twitter?plan=${planType}&duration=${planDuration}`;
  };

  return (
    <div className={`space-y-3 ${className}`}>
      <Button
        type="button"
        onClick={handleGoogleLogin}
        fullWidth
        variant="outline"
        className="flex items-center justify-center bg-white hover:bg-gray-50 text-gray-700 border-gray-300"
      >
        {/* Google icon as inline SVG */}
        <svg className="h-5 w-5 text-red-600 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512">
          <path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
        </svg>
        Continue with Google
      </Button>
      
      <Button
        type="button"
        onClick={handleTwitterLogin}
        fullWidth
        variant="outline"
        className="flex items-center justify-center bg-white hover:bg-gray-50 text-gray-700 border-gray-300"
      >
        {/* Twitter/X icon as inline SVG */}
        <svg className="h-5 w-5 text-blue-400 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
        </svg>
        Continue with X
      </Button>
    </div>
  );
};

export default SocialLoginButtons;